import { render, staticRenderFns } from "./PreviewGame.vue?vue&type=template&id=3aaa6986&"
import script from "./PreviewGame.vue?vue&type=script&lang=js&"
export * from "./PreviewGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports